import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Button, Card, CardContent } from '@mui/material';
import { toast } from 'react-toastify';
import config from '../config';

const PhotoLibrary = () => {
  const [photoLibraryLink, setPhotoLibraryLink] = useState('');

  useEffect(() => {
    const fetchPhotoLibraryLink = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('You are not logged in.');
        return;
      }

      try {
        const response = await fetch(`${config.backendUrl}/api/user/photo-library`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setPhotoLibraryLink(data.photoLibraryLink);
        } else {
          const errorData = await response.json();
          toast.error(`Error: ${errorData.message}`);
        }
      } catch (error) {
        toast.error('An error occurred while fetching the link.');
      }
    };

    fetchPhotoLibraryLink();
  }, []);

  const handleOpenLink = () => {
    if (photoLibraryLink) {
      window.open(photoLibraryLink, '_blank'); // Open the link in a new tab
    } else {
      toast.error('No link available to open.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card
        variant="outlined"
        sx={{
          padding: 3,
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
        }}
      >
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ color: 'black' }}>
            Upload Your Photos and Videos Here
          </Typography>
          {photoLibraryLink ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenLink}
                size="large"
              >
                Upload
              </Button>
            </Box>
          ) : (
            <Typography variant="body2" color="textSecondary">
              Loading your photo library link...
            </Typography>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default PhotoLibrary;
